import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import GeneralMixin from '@/mixins/GeneralMixin';
Vue.use(VueRouter)

const routes = [
  {
    path: '/applications',
    name: 'Applications',
    component: () => import('@/views/Applications.vue'),
    meta: {
      title: 'Chasdei Lev - CRM | Applications',
    },
  },
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: {
      title: 'Chasdei Lev - CRM | Login',
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.IS_AUTHENTICATED ) {
        next({ name: 'Home' }); // go to Home Page If already logged-in
      }
    },
  },
  {
    path      : '/home',
    name      : 'Home',
    component : ()=> import('@/views/LandingPageView.vue'),
    meta : {
      requiresAuth : true,
      //modules      : ['ADMIN-PORTAL','DISTRIBUTION','INVENTORY-RECEIVING','DISPATCHER-LOADING','STOCK-INVENTORY','WAREHOUSE-STAFF'],
      permission   : 'view_home_pages',
      title        : 'Chasdei Lev - CRM | Home'
    }
  },
  {
    path      : '/trailer-loading',
    name      : 'TrailerLoading',
    component : () => import('@/views/TrailerLoading.vue'),
    meta : {
      requiresAuth : true,
      //modules      : 'DISPATCHER-LOADING',
      permission   : 'view_trailer_loading_page',
      title        : 'Chasdei Lev - CRM | Trailer Loading'
    }
  },
  {
    path      : '/palletts',
    name      : 'Paletts',
    component : ()=> import('@/views/Paletts.vue'),
    meta : {
      requiresAuth : true,
      //modules      : 'DISTRIBUTION',
      permission   : 'view_scan_order_pallet_page',
      title        : 'Chasdei Lev - CRM | Scan Pallets'
    }
  },
  // {
  //   path      : '/order-pickup',
  //   name      : 'OrderPickup',
  //   component : ()=> import('@/views/OrderPickup.vue'),
  //   meta : {
  //     requiresAuth : true,
  //     //modules      : 'DISTRIBUTION',
  //     permission   : 'view_scan_order_pickup_page',
  //     title        : 'Chasdei Lev - CRM | Scan Order Pickups'
  //   }
  // },
  {
    path      : '/order-pickups',
    name      : 'OrderPickups',
    component : ()=> import('@/views/OrderPickup.vue'), //added route to new component here
    meta : {
      requiresAuth : true,
      //modules      : 'DISTRIBUTION',
      permission   : 'view_scan_order_pickup_page',
      title        : 'Chasdei Lev - CRM | Scan Order Pickups'
    }
  },
  {
    path: '/receive-stock',
    name: 'ReceiveStock',
    component: ()=> import('@/views/ReceiveStock.vue'),
    meta : {
      requiresAuth : true,
      //modules      : ['INVENTORY-RECEIVING','WAREHOUSE-STAFF'],
      permission   : 'view_receive_stock_page',
      title        : 'Chasdei Lev - CRM | Receive Stock'
    }
  },
  {
    path: '/receive-order-stock',
    name: 'ReceiveOrderStock',
    component: ()=> import('@/views/ReceiveOrderStock.vue'),
    meta : {
      requiresAuth : true,
      permission   : 'view_receive_order_stock_page',
      title        : 'Chasdei Lev - CRM | Receive Order Stock'
    }
  },
  {
    path      : '/scan-pick',
    name      : 'ScanPick',
    component : ()=> import('@/views/ScanPick.vue'),
    meta : {
      requiresAuth : true,
      //modules      : ['DISTRIBUTION','WAREHOUSE-STAFF'],
      permission   : 'view_scan_pick_page',
      title        : 'Chasdei Lev - CRM | Scan Pick'
    }
  },
  // {
  //   path: '/public-pages',
  //   name: 'Public Page',
  //   component: () => import('@/views/PublicPage.vue'),
  //   meta: {
  //     title: 'Chasdei Lev - CRM | Public Pages',
  //     isPublic : true
  //   },
  // },
  {
    path: '/tickets-sold',
    name: 'TicketsTunnel',
    component: () => import('@/views/TicketsTunnel.vue'),
    meta: {
      title: 'Chasdei Lev - CRM | Tickets Sold',
      isPublic : true
    },
  },
  {
    path: '/receive-bol/:uuid',
    name: 'ReceiveBol',
    component: () => import('@/components/trailer/ReceiveBol.vue'),
    meta: {
      title: 'Chasdei Lev - CRM | Receive Trailer',
      isPublic : true
    },
  },
  {
    path: '/search-order-location',
    name: 'SearchOrderLocation',
    component: () => import('@/views/SearchOrderLocation.vue'),
    meta: {
      title: 'Chasdei Lev - CRM | Search Order Location',
      isPublic : true
    },
  },
  {
    path: '/admin',
    component: ()=> import('@/views/Admin.vue'),
     meta : {
      requiresAuth : true,
      //modules      : ['ADMIN-PORTAL','DISTRIBUTION','INVENTORY-RECEIVING','WAREHOUSE-STAFF'],
      permission   : 'view_admin_portal_page',
      title        : 'Chasdei Lev - CRM | Admin'
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: ()=> import('@/components/dashboard/Dashboard.vue'),
        meta : {
          //modules      : 'ADMIN-PORTAL',
          permission   : 'view_dashboard_page',
          showSeason   : false,
        },
      },
      {
        path      : 'orders',
        name      : 'Orders',
        component : ()=> import('@/views/admin/Orders.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','DISTRIBUTION','WAREHOUSE-STAFF'],
          permission   : 'view_order_page',
          showSeason   : true,
        },
      },
      {
        path: 'order-pallets',
        name: 'OrderPallets',
        component: ()=> import('@/views/admin/OrderPallets.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','DISTRIBUTION','WAREHOUSE-STAFF'],
          permission   : 'view_order_pallets_page',
          showSeason   : true,
        },
      },
      {
        path: 'order-pickups',
        name: 'Pickups',
        component: ()=> import('@/views/admin/OrderPickups.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','DISTRIBUTION','WAREHOUSE-STAFF'],
          permission   : 'view_order_pickups_page',
          showSeason   : true,
        },
      },
      {
        path: 'labels',
        name: 'Labels',
        component: ()=> import('@/views/Labels.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','WAREHOUSE-STAFF'],
          permission   : 'view_labels_page',
          showSeason   : false,
        },
      },
      {
        path: 'remote-printing',
        name: 'RemotePrinting',
        component: ()=> import('@/views/RemotePrinting.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','DISTRIBUTION','WAREHOUSE-STAFF'],
          permission   : 'view_remote_printing_page',
          showSeason   : true,
        },
      },
      {
        path: 'vendors',
        name: 'Vendors',
        component: ()=> import('@/views/Vendors.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','INVENTORY-RECEIVING'],
          permission   : 'view_vendors_page',
          showSeason   : false,
        },
      },
      {
        path: 'employees',
        name: 'Employees',
        component: ()=> import('@/views/admin/Employees.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','DISTRIBUTION'],
          permission   : 'view_employees_page',
          showSeason   : true,
        },
      },
      {
        path: 'scan-picking-history',
        name: 'ScanPickingHistory',
        component: ()=> import('@/views/ScanPickingHistory.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','DISTRIBUTION','WAREHOUSE-STAFF'],
          permission   : 'view_scan_picking_history_page',
          showSeason   : true,
        },
      },
      {
        path: 'products',
        name: 'Products',
        component: ()=> import('@/views/admin/Products.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','INVENTORY-RECEIVING'],
          permission   : 'view_products_page',
          showSeason   : true,
        },
      },
      {
        path: 'warehouses',
        name: 'Warehouses',
        component: ()=> import('@/views/Warehouses.vue'),
        meta : {
          //modules      : 'ADMIN-PORTAL',
          permission   : 'view_warehouses_page',
          showSeason   : false,
        },
      },
      {
        path: 'communications',
        name: 'Communications',
        component: ()=> import('@/views/admin/Communications.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','WAREHOUSE-STAFF'],
          permission   : 'view_communications_page',
          showSeason   : false,
        },
      },
      {
        path: 'stocks',
        name: 'Stocks',
        component: ()=> import('@/views/Stocks.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','INVENTORY-RECEIVING'],
          permission   : 'view_stocks_page',
          showSeason   : true,
        },
      },
      {
        path: 'distribution-requests',
        name: 'DistributionRequests',
        component: ()=> import('@/views/DistributionRequests.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','DISTRIBUTION'],
          permission   : 'view_distribution_request_page',
          showSeason   : true,
        },
      },
      {
        path: 'listing',
        name: 'AdminListing',
        component: ()=> import('@/components/admins/Listing.vue'),
        meta : {
          //modules      : 'ADMIN-PORTAL',
          permission   : 'view_admins_page',
          showSeason   : false,
        },
      },
      {
        path: 'user-roles',
        name: 'UserRole',
        component: ()=> import('@/views/RolesPermissionView.vue'),
        meta : {
          //modules      : 'ADMIN-PORTAL',
          permission   : 'view_roles_and_permissions_page',
          showSeason   : false,
        },
      },
      {
        path: 'settings',
        name: 'Settings',
        component: ()=> import('@/views/admin/Settings.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL'],
          permission   : 'view_settings_page',
          showSeason   : false,
        },
      },
      {
        path: 'seasons',
        name: 'Seasons',
        component: ()=> import('@/views/Seasons.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL'],
          permission   : 'view_seasons_page',
          showSeason   : false,
        },
      },
      // {
      //   path: 'documents',
      //   name: 'Documents',
      //   component: ()=> import('@/views/DocumentsView.vue'),
      //   meta : {
      //     modules      : ['ADMIN-PORTAL'],
      //     permission   : 'read',
      //   },
      // },
      {
        path: 'manage-audio',
        name: 'ManageAudio',
        component: ()=> import('@/views/ManageAudio.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','WAREHOUSE-STAFF'],
          permission   : 'view_manage_audio_page',
          showSeason   : false,
        },
      },
      {
        path: 'purchase-orders',
        name: 'Purchase Orders',
        component: ()=> import('@/views/PurchaseOrders.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','INVENTORY-RECEIVING'],
          permission   : 'view_purchase_orders_page',
          showSeason   : true,
        },
      },
      {
        path      : 'trailers',
        name      : 'Trailers',
        component : ()=> import('@/views/admin/Trailers.vue'),
        meta : {
          //modules      : ['ADMIN-PORTAL','DISTRIBUTION','WAREHOUSE-STAFF'],
          permission   : 'view_trailers_page',
          showSeason   : true,
        },
      },
      {
        path      : 'charts',
        name      : 'Charts',
        component : ()=> import('@/views/Charts.vue'),
        meta : {
          permission   : 'view_charts_page',
          showSeason   : true,
        },
      },
      {
        path: 'tags',
        name: 'Tags',
        component: ()=> import('@/views/admin/Tags.vue'),
        meta : {
          permission   : 'view_tags_page',
          showSeason   : true,
        },
      },
      {
        // Generated from the feature registry, so it cannot drift out of date
        // the way a hand-written manual would.
        path: 'help',
        name: 'FeatureCatalog',
        component: ()=> import('@/views/admin/FeatureCatalog.vue'),
        meta : {
          permission   : 'view_admin_portal_page',
          showSeason   : false,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

/*Validate the LOGGED IN STATE*/
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.IS_AUTHENTICATED && to.name !== 'Login') {
      next({ name: 'Login' }); // go to Login Page
    } else {
      if(GeneralMixin.methods.can(to.meta.permission))
      {
        next();// go to wherever I'm going
      }
      else
      {
        /*
         * This branch used to log and then fall through without calling next(),
         * which left the navigation hanging forever: the click did nothing and
         * the only trace was a console line nobody sees. Now it says so and
         * resolves the navigation.
         */
        Vue.prototype.$bus.$emit('show-snackbar', {
          text  : 'You do not have permission to open that page.',
          color : 'error',
        });

        if (from.name) {
          next(false); // stay where we were
        } else if (to.name === 'Home') {
          next(false); // nowhere left to send them; do not loop on Home
        } else {
          next({ name: 'Home' }); // opened straight into a blocked page
        }
      }
    }
  } else {
    next(); // does not require auth, make sure to always call next()! //Login Page
  }

  // Set the document title based on the meta title of the matched route
  const pageTitle = to.meta.title || 'Chasdei Lev - CRM'; // Set a default title if none provided
  document.title = pageTitle;
});

export default router;
